import type { CollapseProps } from "antd";

import Info from "./Info";
import DiscoveryContentDetail from "./DiscoveryContentDetail";

export const InputStyle = { 
	height: "40px",
	width: "100%",
	marginBottom: "10px",
};
export const labelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	width: "120px",
	fontSize: "15px",
};

export const panelStyle: React.CSSProperties = {
	border: "none",
};

export const DiscoveryContentConstants = {
	INFO: "Genel Bilgiler",
	CONTENT_DETAIL_TR: "Türkçe İçerik Detayı",
	CONTENT_DETAIL_EN: "İngilizce İçerik Detayı",
};

export const DiscoveryItems: CollapseProps["items"] = [
	{
		key: "1",
		label: DiscoveryContentConstants.INFO,
		children: <Info />,
		style: panelStyle,
	},
	{
		key: "2",
		label: DiscoveryContentConstants.CONTENT_DETAIL_TR,
		children: <DiscoveryContentDetail isEnContent={false} />,
		style: panelStyle,
	},
	{
		key: "3",
		label: DiscoveryContentConstants.CONTENT_DETAIL_EN,
		children: <DiscoveryContentDetail isEnContent={true} />,
		style: panelStyle,
	}			
];
